<nav *ngIf="supportedLanguages$ | async; let supportedLanguages">
  <ul class="p-0 m-0">
    <li *ngFor="let language of supportedLanguages" class="text-kxlightgrey">
      <button [disabled]="isCurrentLanguage(language)" (click)="changeLanguage(language)" class="btn btn-link p-0 font-size-s" >
        {{ language }}
      </button>
    </li>
  </ul>
</nav>
